module.exports = __webpack_public_path__ + "img/c3-tit2.9569979b.png";